// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aerodrome-markings.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aerodrome-markings/aerodrome-markings.js';

mount([g0]);
